import axios from "axios";
import {limpiarNumero} from "../../Modulo_ChatWass/Funciones/limpiarNumero";
import {obtenerIndicativoPais} from "../../Modulo_ChatWass/Funciones/obtenerIndicativoPais";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {where} from "firebase/firestore";

export const enviarNotificacionFila = async (entidad) => {

    let wheres = [where('estado', '==', 'Nuevo')]
    let numAntes = await contarWheres({coleccion: 'filas', wheres: wheres})

    let obj = {
        celular: obtenerIndicativoPais(entidad.pais) + limpiarNumero(entidad.celular),
        mensaje: `Casa de los cristales dice: \n
${entidad.nombre}, su lugar en la fila a sido apartado con el numero ${entidad.consecutivo}\nHay ${numAntes.data} personas antes de usted\nLe Avisaremos cuando tengamos listo una mesa para usted`
    }

    let data = JSON.stringify(obj);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/e41d5bcf-f95d-41da-91cc-aabfa4e52202', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/e41d5bcf-f95d-41da-91cc-aabfa4e52202',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
            return true
        })
        .catch((error) => {
            console.log(error);
            return false
        });

}